var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 118,
    viewBox: "0 0 418 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.912 0H302.574V39.3382H341.912V0Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.376 0H224.038V39.3382H263.376V0Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.589 0H381.25V39.3382H420.589V0Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.714 0H263.376V39.3382H302.714V0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.251 0H341.912V39.3382H381.251V0Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.659 9.8893L233.859 0.0893555L224.059 9.8893L233.859 19.6893L243.659 9.8893Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.271 9.85756L253.471 0.0576172L243.671 9.85756L253.471 19.6575L263.271 9.85756Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.691 29.5011L233.891 19.7012L224.091 29.5011L233.891 39.3011L243.691 29.5011Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.303 29.4696L253.503 19.6697L243.703 29.4696L253.503 39.2696L263.303 29.4696Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.775 0L302.574 9.79954V0H292.775Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.975 0H273.176L302.574 29.3986V19.5991L282.975 0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.376 0L302.574 39.3382H292.775L263.376 9.79955V0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.376 19.5991L282.975 39.3382H273.176L263.376 29.3987V19.5991Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.25 29.3987L371.311 39.3382H381.25V29.3987Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.251 19.5991V9.79956L351.712 39.3382H361.511L381.251 19.5991Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.251 0L341.912 39.3382V29.3986L371.311 0H381.251Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.511 0L341.912 19.5991V9.79954L351.712 0H361.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.376 39.1851V78.5233H302.714V39.1851H263.376Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.663 39.2737V78.6118H342.001V39.2737H302.663Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.95 39.2227V78.5609H381.288V39.2227H341.95Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.574 39.3381V78.6763H341.912C341.912 56.8373 324.273 39.3381 302.574 39.3381Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.574 49.1377V78.5363H331.973C332.113 62.2971 318.953 49.1377 302.574 49.1377Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.977 39.3306L263.377 58.9305L282.977 78.5304L302.577 58.9305L282.977 39.3306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.912 78.5363L361.511 58.9372L341.912 39.3381V78.5363Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.287 78.4722V117.81H302.625V78.4722H263.287Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 78.5232V117.861H263.338V78.5232H224Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.637 108.075C249.049 108.075 253.436 103.688 253.436 98.2754C253.436 92.8632 249.049 88.4758 243.637 88.4758C238.225 88.4758 233.837 92.8632 233.837 98.2754C233.837 103.688 238.225 108.075 243.637 108.075Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.975 88.3357C288.435 88.3357 292.775 92.6755 292.775 98.1352C292.775 103.595 288.435 107.935 282.975 107.935C277.515 107.935 273.175 103.595 273.175 98.1352C273.175 92.8155 277.515 88.3357 282.975 88.3357Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 418,
    height: 118,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome6);
export default __webpack_public_path__ + "static/media/home6.26a29cc2aae2d87745abed3c6cfb7fe1.svg";
export { ForwardRef as ReactComponent };